import React, { FC, ReactNode, useEffect, useState } from 'react';
// import React, { FC, ReactNode, useContext, useEffect, useState } from 'react';
// import { ThemeContext } from 'styled-components';
import { FormLayout as FormLayoutCore } from 'ia-react-core';
import { NeedHelp } from 'aw-package-react-authentication';
import { getHomePageUrl } from '~/utils/urlUtils';
import { useFooterLinks } from 'omni-package-react-core';
import MobileSmartBanner from '~/components/MobileSmartBanner';
import { StyledBackground } from './FormLayout.styles';
export interface FormLayoutProps {
  children: ReactNode;
}

const FormLayout: FC<FormLayoutProps> = ({ children }) => {
  interface FooterLink {
    text: string;
    url?: string;
    target?: '_blank' | '_self' | '_parent' | '_top' | undefined;
  }

  // const theme = useContext(ThemeContext);

  const [footerLinks, setFooterLinks] = useState<(FooterLink & { target?: string | undefined })[]>([]);

  const footerLinksFromOmniCore = useFooterLinks();
  useEffect(() => {
    if (footerLinksFromOmniCore) {
      const links: FooterLink[] = [
        {
          text: 'FAQ',
          url: '/faq',
        },
        {
          text: 'iA',
          url: 'https://ia.ca',
          target: '_blank',
        },
        ...footerLinksFromOmniCore,
      ];
      setFooterLinks(links);
    }
  }, [footerLinksFromOmniCore]);

  return (
    <>
      <FormLayoutCore
        noFooterLanguageButton={false}
        mainFooterLinks={footerLinks}
        contentBackground="transparent"
        headerBackground="white"
        noHeaderLanguageButton
        homePageUrl={getHomePageUrl()}
        horizontalLogo
        fullContentHeight
      >
        <FormLayoutCore.BeforeHeader>
          <MobileSmartBanner></MobileSmartBanner>
        </FormLayoutCore.BeforeHeader>
        <FormLayoutCore.MainHeaderRightContent>
          <NeedHelp />
        </FormLayoutCore.MainHeaderRightContent>
        {children}
      </FormLayoutCore>
      <StyledBackground data-testid="StyledBackground" role="presentation" />
    </>
  );
};

export default FormLayout;
